import * as Sentry from '@sentry/react';
import {createBrowserRouter, Navigate} from 'react-router-dom';
import {ActionClassRoutes} from '../action-classes/routes.tsx';
import {ActionCodeRoutes} from '../action-codes/routes.tsx';
import {App} from '../app';
import {CodeRoutes} from '../codes/routes.tsx';
import {CosSelectionOptionRoutes} from '../cos-selection-options/routes.tsx';
import {Env} from '../config/env-vars';
import {DemoRoutes} from '../demo/routes.tsx';
import {EmailEvaluationRoutes} from '../email-evaluations/routes.tsx';
import {EmailLogRoutes} from '../email-logs/routes.tsx';
import {FieldRoutes} from '../fields/routes.tsx';
import {JobReviewRoutes, ReviewRoutes} from '../jobs/reviews/routes.tsx';
import {JobRoutes} from '../jobs/routes.tsx';
import {LogsRoutes} from '../logs/routes';
import {PartnerSiteRoutes} from '../partner-sites/routes.tsx';
import {RigRoutes} from '../rigs/routes.tsx';
import {SerialNumberTrackingRoutes} from '../serial-number-tracking/routes.tsx';
import {RepairDocumentsRoutes} from '../repair-documents/routes.tsx';
import {RoutePatternRoutes} from '../route-patterns/routes';
import {SettingRoutes} from '../settings/routes';
import {UserRoutes} from '../users/routes';
import {Callback} from './callback';
import {ROUTES} from './index';
import {DashboardRoutes} from '../dashboard/routes.tsx';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const AppRouter = sentryCreateBrowserRouter(
  [
    {
      element: <App />,
      children: [
        {
          path: ROUTES.CALLBACK.path,
          element: <Callback />,
        },
        DashboardRoutes,
        LogsRoutes,
        ActionClassRoutes,
        JobReviewRoutes,
        ReviewRoutes,
        JobRoutes,
        RepairDocumentsRoutes,
        ActionCodeRoutes,
        CosSelectionOptionRoutes,
        CodeRoutes,
        PartnerSiteRoutes,
        RigRoutes,
        SerialNumberTrackingRoutes,
        RoutePatternRoutes,
        FieldRoutes,
        EmailEvaluationRoutes,
        EmailLogRoutes,
        SettingRoutes,
        UserRoutes,
        DemoRoutes,
      ],
    },
    {
      path: '*',
      element: <Navigate to={ROUTES.ADMIN.JOBS.INDEX.path} />,
    },
  ],
  {basename: Env.subdirectory},
);
